import React, { 
    Component,
    PropTypes,
} from 'react'
import prefix from 'react-prefixer'

class SunMoonPlot extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      height: 0
    }
  }

  componentDidMount() {
    const height = $('#introduction .sun-moon-plot').get(0).clientWidth
    this.setState({height})
  }

  render() {
    let {degree} = this.props
    let {height} = this.state
    let style = prefix({
      transform: `rotate(${degree}deg)`,
      margin: `${0-height/2}px 0 0 ${0-height/2}px`,
      height
    })
    // style = _.extend(style, transformStyle)
    return <div 
      className='sun-moon-plot' 
      style={style}>
      <div className='sun'></div>
      <div className='moon'></div>
      <div className='circle'></div>
    </div>
  }
}

module.exports = SunMoonPlot



/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/sun_moon_plot.js
 **/